export default {
    name: "Sea Export",
    meta: {
        icon: "directions_boat",
        expanded: true,
        auth: true
    },
    departmentName: "Client",
    finalPagePermision: "",
    children: [{
        name: "Sea-Export Normal Details",
        path: "/SeaExp/clientSeaExpNormal",
        meta: {
            icon: "directions_boat",
            auth: true
        },
        component: require("../component/clientDashboard/clientSeaExpNormal.vue"),
        finalPagePermision: "",

    },
    {
        name: "Sea-Export Conso Details",
        path: "/SeaExp/clientSeaExpConso",
        meta: {
            icon: "directions_boat",
            auth: true
        },
        component: require("../component/clientDashboard/clientSeaExpConso.vue"),
        finalPagePermision: "",

    },


    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/clientSeaExpDash.js